import { useState } from 'react';
import { getCloneMenu, getMenuTemplateClone } from '@/services/CloneMenu/cloneMenu';
import { ICloneMenu } from '@/services/CloneMenu';
import { getKhauPhanAn } from '@/services/KhauPhanAn/khauphanan';
import {getBaoCao} from "@/services/ThucPham/BaoCao/baocaothucpham";
import moment from "moment-timezone";
import {BaoCaoThucPham} from "@/models/xuatbaocaothucpham";
import {str2bytes} from "@/utils/utils";

export default () => {
  const [danhSach, setDanhSach] = useState<ICloneMenu.Record[]>([]);
  const [record, setRecord] = useState<ICloneMenu.Record>();
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [pageHocPhi, setPageHocPhi] = useState<number>(1);
  const [limitHocPhi, setLimitHocPhi] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [loaiHinh, setLoaiHinh] = useState<string>('Mầm non');
  const [dataKhauPhanAn, setDataKhauPhanAn] = useState<ICloneMenu.Record>();

  const getDataCloneMenu = async (
    loaiHinhSchool?: string | 'Mầm non' | 'Nhà trẻ',
    donViId?: string,
  ) => {
    setLoading(true);
    const response = await getCloneMenu(
      {
        cond: { ...cond, donViId },
      },
      loaiHinhSchool,
    );
    setDanhSach(response?.data?.data ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getKhauPhanAnTruong = async (donViId: string, ngay: number, thang: number, nam: number) => {
    setLoading(true);
    try {
      const response = await getMenuTemplateClone({
        donViId: donViId,
        ngay: ngay,
        thang: thang,
        nam: nam,
        loaiHinh: loaiHinh,
      });
      setDataKhauPhanAn(response?.data?.data ?? null);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const exportThucDonTuan = async(donViId: string, date: moment.MomentInput) =>{
    setLoading(true);
    try {
      getBaoCao({
        donViId: donViId,
        nhomLop: loaiHinh,
        endDate: moment(date),
        startDate: moment(date),
        types: [BaoCaoThucPham.THUC_DON_TUAN],
        filters: {isMenuTruong: true}
      }).then((response)=>{
        setLoading(false);
        const data = response.data.data;
        const content = data.content;
        const isZip = !!data.isZip;
        const blob = new Blob([str2bytes(content)],{type: isZip?"application/zip":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        const href = URL.createObjectURL(blob);

        // create "a" HTLM element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        const startDate = moment(date)
          .weekday(0)
          .format('YYYY-MM-DD');
        const endDate = moment(date)
          .weekday(6)
          .format('YYYY-MM-DD');
        link.setAttribute('download', `thuc-don-tuan-${startDate}_${endDate}.${isZip?"zip":"xlsx"}`); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    } catch (e) {
      throw e;
      setLoading(false);
    }
  }
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getDataCloneMenu,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    setPageHocPhi,
    setLimitHocPhi,
    pageHocPhi,
    limitHocPhi,
    loaiHinh,
    setLoaiHinh,
    getKhauPhanAnTruong,
    dataKhauPhanAn,
    exportThucDonTuan,
  };
};
